var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.visible,"width":750,"title":"付款凭证图片","okText":"下载"},on:{"cancel":_vm.cancel,"ok":_vm.down}},[_c('div',{staticClass:"img_box"},[_c('img',{staticClass:"img",attrs:{"src":_vm.img,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }